import { render, staticRenderFns } from "./StickycCta.vue?vue&type=template&id=12c8f319&scoped=true"
import script from "./StickycCta.vue?vue&type=script&lang=js"
export * from "./StickycCta.vue?vue&type=script&lang=js"
import style0 from "./StickycCta.vue?vue&type=style&index=0&id=12c8f319&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8f319",
  null
  
)

export default component.exports